import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  TranslateModule,
  TranslateLoader,
  TranslateService
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { SetInterceptorService } from './core/interceptor/set-interceptor.service';
import { GetInterceptorService } from './core/interceptor/get-interceptor.service';
import { AfterLoginSharedModule } from './shared/after-login.shared.module';
import { ToastrModule } from 'ngx-toastr';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { APP_INITIALIZER, NgModule, isDevMode } from '@angular/core';
import { FooterComponent } from './shared/components/footer/footer.component';
import { InitialService } from './core/services/initial.service';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { ServiceWorkerModule } from '@angular/service-worker';
import {
  GoogleLoginProvider,
  SocialAuthServiceConfig,
  SocialLoginModule
} from '@abacritt/angularx-social-login';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

type FactoryFunction = () => Promise<void>;

export function initialServiceFactory(
  initialService: InitialService
): FactoryFunction {
  return () => initialService.setUpGoogleScript();
}

@NgModule({
  declarations: [AppComponent, MainLayoutComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    HeaderComponent,
    FooterComponent,
    AppRoutingModule,
    SharedModule,
    NgxUiLoaderModule,
    GooglePlaceModule,
    MatMenuModule,
    MatSidenavModule,
    AfterLoginSharedModule,
    SocialLoginModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],

  exports: [TranslateModule],
  providers: [
    TranslateService,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '93257152717-o7dkg3gpluprnf9i7r88l2sifb7fosfp.apps.googleusercontent.com'
            )
          }
        ],
        onError: err => {
          console.error(err);
        }
      } as SocialAuthServiceConfig
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initialServiceFactory,
      deps: [InitialService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SetInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GetInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
